import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="yu-baby"
export default class extends Controller {
  static targets = [
    'loading',
    'error',
    'errorQuestion',
    'errorMessage',
    'container',
    'userForm',
    'userMessagesForm',
    'messageForm',
    'messageQuestionField',
    'messageSubmitBtn',
    'newMessageForm',
    'newMessageQuestion',
    'loadMoreForm',
    'blankMessage',
    'formArea'
  ]

  static values = {
    userId: Number,
    yuBabyUserId: Number,
    returnMessageId: Number,
    returnPositionOffset: Number
  }

  static outlets = ['yu-baby-message']

  async initialize() {
    if (this.yuBabyUserIdValue) {
      this.getMessages()
    }
    else if (this.hasUserFormTarget) {
      this.loadingTarget.dataset.show = true
      this.createUser()
    }
  }

  connect() {
    this.containerTarget.scrollTo(0, this.containerTarget.scrollHeight)
    this.initializeReturnPositionOffset()
    this.checkLoadMore()
  }

  initializeReturnPositionOffset() {
    if (this.hasLoadMoreFormTarget) {
      const containerPaddingTop = parseInt(getComputedStyle(this.containerTarget).paddingTop, 10)
      const loadMoreFormHeight = this.loadMoreFormTarget.offsetHeight
      this.returnPositionOffsetValue = containerPaddingTop + loadMoreFormHeight
    }
  }

  createUser() {
    if (!this.hasUserFormTarget) return
    this.userFormTarget.requestSubmit()
  }

  setUpMessage() {
    if (!this.hasMessageQuestionFieldTarget) return
    if (!this.messageQuestionFieldTarget.value) return

    this.disableMessageForm()
    this.errorTarget.dataset.show = false
    this.errorQuestionTarget.textContent = ''
    this.errorMessageTarget.textContent = ''
    this.newMessageQuestionTarget.value = this.messageQuestionFieldTarget.value
    this.newMessageFormTarget.requestSubmit()
  }

  createMessage() {
    if (!this.hasMessageFormTarget) return
    this.messageFormTarget.requestSubmit()
  }

  getMessages() {
    if (!this.hasUserMessagesFormTarget) return
    this.userMessagesFormTarget.requestSubmit()
  }

  toggleSubmitBtn() {
    if (!this.hasMessageSubmitBtnTarget) return
    this.messageSubmitBtnTarget.disabled = !this.messageQuestionFieldTarget.value
  }

  disableMessageForm() {
    if (!this.hasMessageQuestionFieldTarget) return
    this.messageQuestionFieldTarget.readOnly = true
    this.messageSubmitBtnTarget.disabled = true
  }

  enableMessageForm() {
    if (!this.hasMessageQuestionFieldTarget) return
    this.messageQuestionFieldTarget.value = ''
    this.messageQuestionFieldTarget.readOnly = false
    this.toggleSubmitBtn()
  }

  removeBlankMessage() {
    if (this.hasBlankMessageTarget) {
      this.blankMessageTarget.remove()
    }
  }

  setErrorMessage({ question, errorMessage }) {
    this.errorTarget.dataset.show = true
    this.errorQuestionTarget.textContent = question
    this.errorMessageTarget.textContent = errorMessage
    this.errorMessageTarget.scrollIntoView({ behavior: 'instant', block: 'end' })
    this.enableMessageForm()
  }

  checkLoadMore() {
    if (this.hasLoadMoreFormTarget && this.containerTarget.scrollTop === 0 && !this.loadMoreFormTarget.dataset.loading) {
      this.loadMoreFormTarget.dataset.loading = true
      if (this.hasYuBabyMessageOutlet) {
        this.returnMessageIdValue = this.yuBabyMessageOutlets[0].element.dataset.yuBabyMessageId
      }
      this.loadMoreFormTarget.requestSubmit()
    }
  }

  // メッセージ追加後、ページ最上部からロード前の場所に戻る
  returnToFirstBeforeLoadMessage() {
    const firstMessage = this.yuBabyMessageOutlets.find((yuBabyMessage) => (
      parseInt(yuBabyMessage.element.dataset.yuBabyMessageId) === this.returnMessageIdValue
    ))
    if (firstMessage) {
      this.containerTarget.scrollTo(0, firstMessage.element.offsetTop - this.returnPositionOffsetValue)
    }
  }
}
